import * as yup from 'yup'
import { InferType } from 'yup'

import { DESCRIPTION_MAX_LENGTH } from '@/constants'
import { TTranslationFunction } from '@/types'

import { urlSchema } from '../fieldSchemas'

export const HEADLINE_MAX_LENGTH = 50
export const BUTTON_TITLE_MAX_LENGTH = 50

export const getImagesInfoFormSchema = (t: TTranslationFunction) =>
	yup
		.object({
			headline: yup
				.string()
				.required(t('ui__field_validation_errors__generic__required'))
				.max(
					HEADLINE_MAX_LENGTH,
					t('ui__field_validation_errors__generic__max_length', {
						length: HEADLINE_MAX_LENGTH,
					}),
				),

			info: yup.object({
				website: urlSchema(t, { required: false }),
			}),

			description: yup
				.string()
				.notRequired()
				.max(
					DESCRIPTION_MAX_LENGTH,
					t('ui__field_validation_errors__generic__max_length', {
						length: DESCRIPTION_MAX_LENGTH,
					}),
				),

			buttons: yup
				.array(
					yup.object({
						title: yup
							.string()
							.required(t('ui__field_validation_errors__generic__required'))
							.max(
								BUTTON_TITLE_MAX_LENGTH,
								t('ui__field_validation_errors__generic__max_length', {
									length: BUTTON_TITLE_MAX_LENGTH,
								}),
							),
						url: urlSchema(t, { required: true }),
					}),
				)
				.required(),
		})
		.required()

export type TImagesInfoFields = InferType<
	ReturnType<typeof getImagesInfoFormSchema>
>

export type TImagesButton = TImagesInfoFields['buttons'][number]
